export default __webpack_public_path__ + "static/media/gaming_Footer_SabaSports_Supplier.41855339.svg";